// import { randomBytes } from 'react-native-randombytes'
import { Buffer } from 'buffer';
import * as bip39 from 'bip39'
import '@ethersproject/shims'
import * as ethers from 'ethers'

// solana lib
// import * as ed25519 from 'ed25519-hd-key';
import { derivePath, getMasterKeyFromSeed } from 'ed25519-hd-key';
import { Keypair } from '@solana/web3.js';
import bs58 from 'bs58';

// ton lub
import { mnemonicToWalletKey } from '@ton/crypto';
import { WalletContractV4 } from '@ton/ton';
// import { mnemonicNew, mnemonicToWalletKey } from 'ton-crypto';
// import { TonClient, WalletContractV4 } from 'ton';

if (typeof window !== 'undefined') {
    window.Buffer = Buffer;  // 브라우저에서 Buffer를 전역 객체로 설정
}

/**
 * 지갑주소 생성
 * @param chainName 
 * 
 * @returns {privateKey, publicKey, address, mnemonic}
 */
const generateWallet = async (chainName:string) => {

    let wallet = {
        privateKey: '',
        publicKey: '',
        address: '',
        mnemonic: '',
    }

    console.log(`useWallet generateWallet chainName : ${chainName}`)
    try {
        // 니모닉 생성
        const mnemonic = generateMnemonic()
        
        if(process.env.REACT_APP_SOLANA_NETWORK_NAME?.toLowerCase() === chainName.toLowerCase()) {
            wallet = generateSolanaWallet(mnemonic)
        } else if(process.env.REACT_APP_BSC_NETWORK_NAME?.toLowerCase() === chainName.toLowerCase()) {
            wallet = generateEthWallet(mnemonic)
        } else if(process.env.REACT_APP_TON_NETWORK_NAME?.toLowerCase() === chainName.toLowerCase()) {
            wallet = await generateTonWallet(mnemonic)
        }
        else {
            wallet = {
                privateKey: '',
                publicKey: '',
                address: '',
                mnemonic: ''
            }
        }
    } catch(error) {
        console.error(`Error generateWallet`, error)
    }

    return {
        privateKey: wallet.privateKey,
        publicKey: wallet.publicKey,
        address: wallet.address,
        mnemonic: wallet.mnemonic,
    }
}

const generateMnemonic = () => {
    const startTime = Date.now()

	console.log(`mnemonic 생성 시작 : ${startTime}`)

    const entropyArray = new Uint8Array(16)
    crypto.getRandomValues(entropyArray)
    const entropy = Buffer.from(entropyArray).toString('hex')
    const entropyTime = Date.now()
    const entropyTake = entropyTime - startTime
    console.log(`entropyTake : ${entropyTake} ms`)

    const mnemonic = bip39.entropyToMnemonic(entropy)
    const mnemonicTime = Date.now()
    const mnemonicTake = mnemonicTime - entropyTime
    console.log(`mnemonicTake : ${mnemonicTake} ms`)

    console.log(`mnemonic 생성 종료`)

    return mnemonic
}

/**
 * ethers 지갑 생성
 * @returns 
 */
const generateEthWallet = (mnemonic:string) => {
    const startTime = Date.now()

	console.log(`gen eth wallet start : ${startTime}`)

    // const mnemonic = generateMnemonic()

    const hdNode = ethers.utils.HDNode.fromMnemonic(mnemonic)
    const hdNodeTime = Date.now()
    const hdNodeTake = hdNodeTime - startTime
    console.log(`hdNodeTake : ${hdNodeTake} ms`)

    const wallet = hdNode.derivePath(`m/44'/60'/0'/0/0`)
    const walletTime = Date.now()
    const walletTake = walletTime - hdNodeTime
    console.log(`walletTake : ${walletTake} ms`)

    return {
        privateKey: wallet.privateKey,
        publicKey: wallet.publicKey,
        address: wallet.address,
        mnemonic: mnemonic
    }
}

/**
 * solana 지갑 생성
 * @returns 
 */
const generateSolanaWallet = (mnemonic:string) => {
    const startTime = Date.now()
    console.log(`solana 지갑 생성 시작 : ${startTime}`)
    
    // 니모닉 생성
    // const mnemonic = generateMnemonic()

    // 시드 생성
    const seed = bip39.mnemonicToSeedSync(mnemonic)
    const seedTime = Date.now()
    const seedTake = seedTime - startTime
    // console.log(`seedTake : ${seedTake} ms`)
    // console.log('Seed:', seed.toString('hex'))
    
    // Derive a master key from the seed
	const { key, chainCode } = getMasterKeyFromSeed(seed.toString());
	// console.log('Master Key:', Buffer.from(key).toString('hex'));
	// console.log('Chain Code:', Buffer.from(chainCode).toString('hex'));

    // ed25519 HD 키 생성
    const derivedResult = derivePath("m/44'/501'/0'/0'", seed.toString('hex'))
    // console.log('Derived Key:', Buffer.from(derivedResult.key).toString('hex'))
    const hdTime = Date.now()
    const hdTake = hdTime - seedTime
    // console.log(`hdTake : ${hdTake} ms`)
    
	// Solana 키페어 생성
	const keypair = Keypair.fromSeed(derivedResult.key)
	const keypairTime = Date.now()
	const keypairTake = keypairTime - hdTime
	// console.log(`keypairTake : ${keypairTake} ms`)
	// console.log('Final Keypair:', {
	// 	publicKey: keypair.publicKey.toString(),
	// 	secretKey: Buffer.from(keypair.secretKey).toString('hex')
	// })
    
    const privateKeyBase58 = bs58.encode(keypair.secretKey);
    const publicKey = keypair.publicKey.toString()
    const address = keypair.publicKey.toString()

	// console.log(`privateKey(Base58) : `, privateKeyBase58)
	// console.log(`publicKey : `, publicKey)
	// console.log(`address : `, address)

    return {
        privateKey: privateKeyBase58,
        publicKey: publicKey,
        address: address,
        mnemonic: mnemonic
    }
}

/**
 * ton 지갑 생성
 * @param mnemonic 
 * @returns 
 */
const generateTonWallet = async(mnemonic:string) => {
    const startTime = Date.now()
    console.log(`ton 지갑 생성 시작 : ${startTime}`)

     // (2) 니모닉 → 지갑 키 (ed25519)
    const mnemonicArray = mnemonic.trim().split(' ')
    // console.log(`generateTonWallet mnemonicArray : ${mnemonicArray}`)    
    const keyPair = await mnemonicToWalletKey(mnemonicArray);
    const { publicKey, secretKey } = keyPair;
    // console.log(`generateTonWallet publicKey : `, Buffer.from(publicKey).toString('hex'))
    // console.log('generateTonWallet secretKey :', Buffer.from(secretKey).toString('hex'))

    // (3) WalletContractV4 인스턴스 생성
    // workchain=0 (메인넷)
    const wallet = WalletContractV4.create({ 
        publicKey, 
        workchain: 0 
    });

    // (4) 지갑 주소
    // wallet.address는 이미 계산된 주소 (오프라인 계산)
    // non-bouncalbe 주소로 설정해야 처음 보유량 0일 때 받은 ton 코인이 반송되지 않음
    const walletAddress = wallet.address.toString({bounceable: false}); 
    // console.log(`generateTonWallet walletAddress : `, walletAddress)

    return {
        privateKey: Buffer.from(secretKey).toString('hex'),
        publicKey: Buffer.from(publicKey).toString('hex'),
        address: walletAddress,
        mnemonic: mnemonicArray.join(' '),
    };
}

/**
 * 비밀복구문구로 지갑 복구
 * @param secretPhrase 
 * @returns 
 */
const recoveryWallet = async (secretPhrase:string, chainName:string) => {
	const trimmedSecretPhrase = secretPhrase.trim()

	if (false === bip39.validateMnemonic(trimmedSecretPhrase)) {
		console.log(`bip39.validateMnemonic 실패`)
		return {
			privateKey: null,
			publicKey: null,
			address: null
		}
	}

	const arrayMnemonic = trimmedSecretPhrase.split(/\s+/)
	const storedMnemonic = JSON.stringify(arrayMnemonic)

	const mnemonicArray = JSON.parse(storedMnemonic)
	const mnemonic = Array.isArray(mnemonicArray) ? mnemonicArray.join(' ') : mnemonicArray

	if (mnemonic.split(' ').length % 3 === 0) {

        let wallet
        if(process.env.REACT_APP_SOLANA_NETWORK_NAME?.toLowerCase() === chainName.toLowerCase()) {            
            wallet = generateSolanaWallet(mnemonic)
        } else if(process.env.REACT_APP_BSC_NETWORK_NAME?.toLowerCase() === chainName.toLowerCase()) {
            wallet = generateEthWallet(mnemonic)
        } else if(process.env.REACT_APP_TON_NETWORK_NAME?.toLowerCase() === chainName.toLowerCase()) {
            wallet = await generateTonWallet(mnemonic)
        }
        else {
            // 일치하는 네트워크 없을 경우 빈 값 리턴
            wallet = { 
                privateKey: null,
                publicKey: null,
                address: null,
            }
        }

		return {
			privateKey: wallet.privateKey,
			publicKey: wallet.publicKey,
			address: wallet.address
		}
	}
	return {
		privateKey: null,
		publicKey: null,
		address: null
	}
}

const useWallet = () => {
    const makeWallet = (chainName:string) => {
        return generateWallet(chainName); // 지갑을 새로 생성
    }

	const restoreWallet = (mnemonic:string, chainName:string) => {
		return recoveryWallet(mnemonic, chainName); // 지갑을 복구
	}

    return {
        makeWallet,  // 다시 생성할 수 있는 메서드 제공
		restoreWallet
    }
}

export default useWallet
